// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active, .fade-leave-active {\r\n    transition: opacity .2s;\r\n}\r\n.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {\r\n    opacity: 0;\r\n}\r\n.test-enter-active, .test-leave-active {\r\n    transition: height .2s;\r\n}\r\n.test-enter, .test-leave-to /* .fade-leave-active below version 2.1.8 */ {\r\n    height: 0;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
